// extracted by mini-css-extract-plugin
export default {"input":"ConfirmModal_input__INK2I","disabledBtn":"ConfirmModal_disabledBtn__TbQsg"};